export class MessaggiUtentiLetti {
	constructor() {
		this.itemIDs = [];
	}

	itemIDs: number[];
}